import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, DestroyRef, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DistanceInfo } from '@core/models/domains/hotel';
import { DistanceModalComponent } from '../../components/distance-modal/distance-modal.component';
import { ModalService } from '@shared/services/modal.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
 selector: 'iho-distance',
 standalone: true,
 imports: [NgIf, NgFor, MatButtonModule, CommonModule],
 templateUrl: './distance.component.html',
 styleUrls: ['./distance.component.scss'],
})
export class DistanceComponent {
 @Input({ required: true }) dataSource?: DistanceInfo = {} as DistanceInfo;
 @Input() nearBies: any;
 dialog = inject(MatDialog);
 modalService = inject(ModalService);

 destroyRef = inject(DestroyRef);

 openModal() {
  const dialogRef = this.dialog.open(DistanceModalComponent, {
   panelClass: [
    'custom-modal',
    'distance-modal',
    'w-screen',
    'lg:w-[600px]',
    'h-screen',
    '!max-w-full',
    'lg:h-[80%]',
   ],
   data: {
    distance: this.dataSource,
    nearBies: this.nearBies,
   },
   autoFocus: false,
  });
  // Handle the result or any other actions as needed
  dialogRef
   .afterClosed()
   .pipe(takeUntilDestroyed(this.destroyRef))
   .subscribe((result) => {
    this.modalService.isAnyModalOpen.set(false);
   });

  dialogRef
   .afterOpened()
   .pipe(takeUntilDestroyed(this.destroyRef))
   .subscribe(() => {
    this.modalService.isAnyModalOpen.set(true);
   });
 }

 lengthData(len: number) {
  return len == 1 ? len : 1;
 }
}
